export default __webpack_public_path__ + "/dist/images/logo3.png";